import SetPasswordPage from "./setPassword";

export default SetPasswordPage;
